<h1 mat-dialog-title *ngIf="!isLoading" xmlns="http://www.w3.org/1999/html">Edit Communication Frequencies</h1>
<div id="spinnerContainer" *ngIf="isLoading">
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</div>
<div *ngIf="!isLoading">
  <mat-dialog-content [formGroup]="formGroup">
      <p>
        <mat-form-field class="inputs">
          <input matInput
                 placeholder="Unicom frequency (format: xxx.xxx)"
                 formControlName="unicomFreq">
        </mat-form-field>
      </p>
      <p>
        <mat-form-field class="inputs">
          <input matInput
                 placeholder="ASRI Frequency (ARINC)(format: xxx.xxx)"
                 formControlName="arincFreq">
        </mat-form-field>
      </p>
      <div id="monitoringCTAF">
        <mat-checkbox formControlName="monitoringCTAF">Monitoring Airport CTAF</mat-checkbox>
      </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="submit-button mat-raised-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="close()">Cancel</button>
  </mat-dialog-actions>
</div>
